import { Alert } from 'shared/mui/Alert/Alert';
import { FilterFields } from 'shared/mui/Filter/FilterFields/FilterFields';

import { useBalanceReportFilterFields } from './hooks/useBalanceReportFilterFields';

export const BalanceReportListFilter: React.FC = () => {
  const fields = useBalanceReportFilterFields();

  return (
    <>
      <Alert severity="warning">
        Период, в рамках которого формируется отчёт, не должен превышать 5 лет
      </Alert>
      <FilterFields fields={fields} />
    </>
  );
};
